import { render, staticRenderFns } from "./nav_bar.vue?vue&type=template&id=19064b84&scoped=true"
import script from "./nav_bar.vue?vue&type=script&lang=js"
export * from "./nav_bar.vue?vue&type=script&lang=js"
import style0 from "./nav_bar.vue?vue&type=style&index=0&id=19064b84&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19064b84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19064b84')) {
      api.createRecord('19064b84', component.options)
    } else {
      api.reload('19064b84', component.options)
    }
    module.hot.accept("./nav_bar.vue?vue&type=template&id=19064b84&scoped=true", function () {
      api.rerender('19064b84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobilePage/nav_bar.vue"
export default component.exports